<script setup lang="ts">
import { useI18n } from '../../../i18n'

const props = defineProps<{ disabled?: boolean; label?: string }>()
const emit = defineEmits<{ (e: 'click'): void }>()

const { t } = useI18n()
</script>

<template>
  <button
    type="button"
    class="pl-btn pl-btn--secondary"
    :disabled="props.disabled"
    @click="emit('click')"
  >
    {{ props.label ?? t('common.skip') }}
  </button>
</template>
